/* ============================================================
   Cleanly cart cross-sell + trust line — placement, carousel,
   and one-click add. Loaded once.
   1) Moves the server-rendered .cl-cross block into the drawer
      content (before the summary) and the .cl-cart-extras trust
      line into the summary, right under the checkout button.
   2) Turns the cross-sell cards into a slow auto-rotating carousel
      with clickable dots + manual swipe/drag. The moment the
      shopper takes control (dot click or swipe) autoplay stops for
      good, so the offer they are looking at never jumps away.
   3) Delegated one-click add-to-cart from the cross-sell cards.
   4) Shows the cart total on the checkout button.
   ============================================================ */
(function () {
  if (window.__clCrossInit) return;
  window.__clCrossInit = true;

  var AUTOPLAY_MS = 5000;

  /* ---------- carousel (transform-based: immune to scroll-snap re-layout,
     and width-independent since slides are moved with translateX %) ---------- */
  function initCarousel(cross) {
    if (!cross) return;
    // Idempotent: if already wired, just make sure autoplay is running
    // (a prior morph may have stopped it) and bail.
    if (cross.dataset.clCarousel === '1') { if (cross._clStart) cross._clStart(); return; }

    var vp = cross.querySelector('.cl-cross__viewport');
    var track = cross.querySelector('.cl-cross__track');
    var dots = cross.querySelector('.cl-cross__dots');
    if (!vp || !track || !dots) return;
    var n = track.querySelectorAll('.cl-cross__card').length;
    cross.dataset.clCarousel = '1';

    if (n <= 1) { dots.style.display = 'none'; return; }

    dots.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cl-cross__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'מעבר להצעה ' + (i + 1));
      (function (idx) {
        b.addEventListener('click', function () { takeOver(); goTo(idx); });
      })(i);
      dots.appendChild(b);
    }
    var dotEls = dots.querySelectorAll('.cl-cross__dot');
    var cur = 0, timer = null, userTook = false;

    function setDots() { for (var i = 0; i < dotEls.length; i++) dotEls[i].classList.toggle('is-active', i === cur); }
    function apply() { track.style.transform = 'translateX(' + (-cur * 100) + '%)'; }
    function goTo(idx) {
      cur = ((idx % n) + n) % n;
      track.style.transition = '';
      apply();
      setDots();
    }
    function next() { goTo(cur + 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    // Never restart a timer that is already running — otherwise every stray
    // click on the page (which triggers a re-placement) would reset the
    // countdown, or worse, stack intervals.
    function start() { if (userTook || timer) return; timer = setInterval(next, AUTOPLAY_MS); }
    // Shopper touched it — hand the carousel over to them permanently.
    function takeOver() { userTook = true; stop(); }

    cross._clStart = start;
    cross._clStop = stop;

    vp.addEventListener('mouseenter', stop);
    vp.addEventListener('mouseleave', start);

    /* manual swipe / drag (touch + mouse) */
    var dragging = false, moved = false, startX = 0, startY = 0, lastX = 0;
    function px(e) { return e.touches && e.touches[0] ? e.touches[0].pageX : e.pageX; }
    function py(e) { return e.touches && e.touches[0] ? e.touches[0].pageY : e.pageY; }
    function down(e) {
      dragging = true; moved = false;
      startX = lastX = px(e); startY = py(e);
      track.style.transition = 'none';
      stop();
    }
    function move(e) {
      if (!dragging) return;
      lastX = px(e);
      var dx = lastX - startX;
      var dy = py(e) - startY;
      // Let a clearly vertical gesture scroll the drawer instead of dragging.
      if (!moved && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) { dragging = false; track.style.transition = ''; apply(); return; }
      if (Math.abs(dx) > 4) {
        moved = true;
        takeOver();
        if (e.cancelable && e.touches) e.preventDefault();
      }
      var w = vp.clientWidth || 1;
      track.style.transform = 'translateX(' + ((-cur * w) + dx) + 'px)';
    }
    function up() {
      if (!dragging) return; dragging = false;
      track.style.transition = '';
      var dx = lastX - startX;
      if (moved && Math.abs(dx) > 28) { takeOver(); goTo(dx < 0 ? cur + 1 : cur - 1); }
      else { apply(); }
    }
    vp.addEventListener('mousedown', down);
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
    vp.addEventListener('touchstart', down, { passive: true });
    vp.addEventListener('touchmove', move, { passive: false });
    vp.addEventListener('touchend', up);
    vp.addEventListener('touchcancel', up);

    setDots();
    apply();
    start();
  }

  /* ---------- placement ---------- */
  function placeCross() {
    var content = document.querySelector('cart-items-component[data-drawer] .cart-drawer__content');
    if (!content) return null;
    var summary = content.querySelector('.cart-drawer__summary');
    var crosses = document.querySelectorAll('cart-items-component[data-drawer] .cl-cross');
    if (!summary || !crosses.length) return null;
    var keep = crosses[crosses.length - 1];
    for (var i = 0; i < crosses.length; i++) { if (crosses[i] !== keep) crosses[i].remove(); }
    if (keep.parentElement !== content || keep.nextElementSibling !== summary) {
      content.insertBefore(keep, summary);
    }
    return keep;
  }

  function placeTrust() {
    var summary = document.querySelector('cart-items-component[data-drawer] .cart-drawer__summary');
    var extrasAll = document.querySelectorAll('cart-items-component[data-drawer] .cl-cart-extras');
    if (!summary || !extrasAll.length) return;
    var keep = extrasAll[extrasAll.length - 1];
    for (var i = 0; i < extrasAll.length; i++) { if (extrasAll[i] !== keep) extrasAll[i].remove(); }
    var ctas = summary.querySelector('.cart__ctas') || summary.lastElementChild;
    if (!ctas || !ctas.parentElement) return;
    // Sit immediately after the checkout button, always.
    if (keep.previousElementSibling !== ctas) {
      ctas.parentElement.insertBefore(keep, ctas.nextSibling);
    }
  }

  // Show the cart total on the checkout button ("מעבר לתשלום · ₪359")
  // instead of a separate subtotal row (which is hidden via CSS).
  function setCheckoutPrice() {
    var scope = document.querySelector('cart-items-component[data-drawer]');
    if (!scope) return;
    var totalRow = scope.querySelector('.cart-totals__total');
    var btnText = scope.querySelector('#checkout .button-text') || scope.querySelector('.cart__checkout-button .button-text');
    if (!totalRow || !btnText) return;
    var label = totalRow.querySelector('.cart-totals__total-label');
    var price = totalRow.textContent;
    if (label) price = price.replace(label.textContent, '');
    price = price.replace(/\s+/g, ' ').trim();
    if (!price) return;
    var want = 'מעבר לתשלום  ·  ' + price;
    if (btnText.textContent.replace(/\s+/g, ' ').trim() !== want.replace(/\s+/g, ' ').trim()) {
      btnText.textContent = want;
    }
  }

  function reposition() {
    var cross = placeCross();
    placeTrust();
    setCheckoutPrice();
    if (cross) initCarousel(cross);
  }

  // setTimeout (not rAF) so re-placement still runs when the tab is
  // backgrounded — rAF is paused in background tabs. Also fire a short
  // burst so we catch the theme's own async cart re-render (morph).
  var repoT;
  function scheduleReposition() {
    if (repoT) clearTimeout(repoT);
    repoT = setTimeout(reposition, 40);
    setTimeout(reposition, 250);
    setTimeout(reposition, 650);
  }

  var observing = false;
  function observe() {
    if (observing) return;
    var drawer = document.querySelector('cart-drawer-component');
    var host = drawer || document.querySelector('cart-items-component[data-drawer]');
    if (!host) return;
    observing = true;
    // Re-renders / morphs of the drawer contents.
    new MutationObserver(scheduleReposition).observe(host, { childList: true, subtree: true });
    // Drawer open/close (attribute toggles on the component itself).
    if (drawer) new MutationObserver(scheduleReposition).observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden', 'class', 'style'] });
  }

  document.addEventListener('cart:update', scheduleReposition);
  document.addEventListener('shopify:section:load', function () { scheduleReposition(); observe(); });
  // Opening the cart is usually a click on a cart toggle — re-place shortly after.
  document.addEventListener('click', scheduleReposition, true);
  window.addEventListener('pageshow', scheduleReposition);
  function boot() { reposition(); observe(); [300, 800, 1600].forEach(function (ms) { setTimeout(reposition, ms); }); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* ---------- one-click add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cl-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-cl-add');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    // Ask /cart/add.js to return the re-rendered cart HTML in the same
    // response, so the drawer updates without two more round trips.
    var payload = { items: [{ id: Number(id), quantity: 1 }] };
    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
    });
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (added) {
        // Full cart for every listener (same as before), plus the rendered
        // sections from the add response so the drawer does not have to
        // fetch them again.
        var sections = (added && added.sections) || null;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
          .then(function (cart) { return { cart: cart, sections: sections }; });
      })
      .then(function (res) {
        var cart = res.cart;
        var data = { source: 'cl-cross', itemCount: cart && cart.item_count };
        if (res.sections) data.sections = res.sections;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'cl-cross', data: data }
        }));
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (err) {} }
        btn.removeAttribute('aria-busy');
        scheduleReposition();
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-cl-add][aria-busy="true"]').forEach(function (b) {
      b.removeAttribute('aria-busy');
    });
  });
})();
